<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'app-download-teaser-fi': true,
        'app-download-teaser-fi--with-image': hasImage,
        'app-download-teaser-fi--dark': fields.dark?.value,
      }"
    >
      <div
        :class="{
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11':
            !hasImage,
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12': hasImage,
        }"
      >
        <div class="app-download-teaser-fi__container">
          <div
            :class="{
              'app-download-teaser-fi__text': true,
              'app-download-teaser-fi__text--with-img': hasImage,
            }"
          >
            <richtext-fi field-name="text" />

            <app-download-buttons-fi
              class="app-download-teaser-fi__buttons"
              :fields="fields"
            />
          </div>
          <div
            v-if="hasImage"
            class="app-download-teaser-fi__image"
          >
            <cloud-image-fi
              field-name="image"
              params="org_if_sml=1"
            />
          </div>
        </div>
      </div>

      <div class="lg:fi-col-start-7 lg:fi-col-end-12" />
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';
import { computed } from 'vue';

import AppDownloadButtonsFi from '@/components/app-download-buttons-fi/AppDownloadButtonsFi.vue';
import CloudImageFi from '@/components/atoms/cloud-image-fi/CloudImageFi.vue';
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';

defineOptions({
  name: 'AppDownloadTeaserFi',
});

const fields = useFields('AppDownloadTeaserFiFields');

const hasImage = computed(() => Boolean(fields.image?.value?.src || fields.image?.editable));
</script>

<style scoped src="./app-download-teaser-fi" />
